import '../css/basic.css';

export default function NotFound () {
    return (
        <div className="centerContent">
            <h1>404 :( </h1>
            <small>Pagina no encontrada</small>
        </div>
    )
}